<template>
  <div>
    <div :key="product.id" v-for="product in products">
      <div
        v-if="product.breadChoices"
        class="product-description"
        style="font-style:italic; margin:10px 0 10px 10px;"
      >
        <span style="color:#F00; font-weight:bold;">Below</span>
        served with choice of White, Wheat, Sourdough or Rye Bread.
      </div>

      <div v-else class="product" :data-product-id="product.id">
        <div class="product-name">
          {{ product.name }}
        </div>

        <div class="product-description" style="white-space:pre-line;">
          {{ product.description }}
        </div>

        <div :key="modifier.id" v-for="modifier in product.modifiers">
          <div class="item_line" style="height:0px; margin-bottom:-15px;"></div>

          <div class="modifier-description">
            {{ modifier.description }}
          </div>
        </div>

        <div class="item_line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductList',

  props: {
    products: {
      type: Array,
      required: true,
    },
  },
};
</script>
